<template>
  <div>
    <div class="form_item" :class="save_to+'_wrapper'">
      <div :id="save_to+'_element'">
        <Label :required="required" :label="label" :for_id="save_to"/>
        <div class="prix_produit_subform" v-for="(pp, index) in prix_produits" :key="index">
          <div class="prix_produit_field">
            <span class="prix_produit_index">{{configuration.labelProductLine || 'Produit'}} {{index+1}}</span>
            <label :for="'produit_'+index">{{configuration.labelRef || 'Référence'}} <span v-if="required && index == 0">*</span></label>
            <Multiselect v-if="options && options.length > 0"
              :options="options"
              label="name"
              :multiple="false"
              v-model="pp.produit"
              :searchable="true"
              :closeOnSelect="true"
              :placeholder="placeholder"
              :limit="undefined"
              :showLabels="false"
              :options-limit="300"
              :track-by="undefined"
            />
            <input
              v-validate="validation"
              v-else
              :id="'produit_'+index"
              type="text"
              :name="(configuration.labelRef || 'Référence')+' ' +(index+1)"
              :key="'produit_'+index"
              v-model="pp.produit"
              :required="required"
              :class="{'has-error': errors.has((configuration.labelRef || 'Référence')+' ' +(index+1)) && ((fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].untouched && !fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].dirty) || (fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].touched && fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].dirty))}"
              :placeholder="placeholder"
            />
            <span
              class="error"
              v-show="errors.has((configuration.labelRef || 'Référence')+' ' +(index+1)) && ((fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].untouched && !fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].dirty) || (fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].touched && fields[(configuration.labelRef || 'Référence')+' ' +(index+1)].dirty))"
              v-text="errors.first((configuration.labelRef || 'Référence')+' ' +(index+1))"
            ></span>

          </div>
          <div class="prix_produit_field" v-if="configuration.displayDescription">
            <label :for="'description_'+index">{{configuration.labelDescription || 'Description'}} <span v-if="required && index == 0">*</span></label>
            <input type="text" name="" :id="'description_'+index" v-model.number="pp.description">
          </div>
          <div class="prix_produit_field" v-if="configuration.displayQuantite">
            <label :for="'quantity_'+index">{{configuration.labelQuantite || 'Quantité'}} <span v-if="required && (index == 0 || pp.produit != undefined)">*</span></label>
            <input type="number" 
            :required="(required && index == 0) || pp.produit != undefined"
            name="" :id="'quantity_'+index" v-model.number="pp.quantity">
          </div>
          <div class="prix_produit_field" v-if="configuration.displayPrix">
            <label :for="'price_'+index">{{configuration.labelPrix || 'Prix unitaire TTC en €'}} <span v-if="required && index == 0">*</span></label>
            <input type="number" step="0.01" name="" :id="'price_'+index" v-model="pp.price">
          </div>
        </div>
        <div class="button-plus">
          <button type="button" @click="prix_produits.push({produit: undefined, price: 0, quantity: 1, description: undefined})">{{configuration.labelPlus || '+'}}</button>
          <button type="button" class="button-retirer-ligne" v-if="prix_produits.length > 1" @click="prix_produits.pop()">{{configuration.labelMoins || '+'}}</button>
        </div>
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
    </div>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import Label from './Label'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Input',
  mixins: [validatorComponent],
  data: function () {
    return {
      validation: {unique: false},
      prix_produits: [{
        produit: undefined,
        price: 0,
        quantity: 1,
      }]
    }
  },
  components: {
    Label,
    Multiselect
  },
  props: {
    label: String,
    placeholder: String,
    validationLabel: String,
    validationRules: [String, Object],
    options: {
      type: Array,
      required: false
    },
    configuration: Object,
    save_to: String,
    required: Boolean,
  },
  created() {

  },
  watch: {
    prix_produits: {
      deep: true,
      handler() {
        let proxy = [...this.prix_produits].map((pp)=>{
          if(pp.produit) {
            return {
              produit: pp.produit.value || pp.produit,
              price: pp.price,
              quantity: pp.quantity
            }
          }
        })
        this.$emit('input', proxy)
      }
    }
  },
  created() {
    let validationRules = {...this.validationRules}
    if(validationRules.included) {
      validationRules.included = validationRules.included.split(',');
    }
    if(this.unique) {
      this.validation = {...validationRules, unique: [this.save_to, this.operationId]};
    } else {
      this.validation = {...validationRules}
    }
      console.log("this.validation", this.validation)
  },
  computed: {
    confirmationName () {
      return this.save_to + '_confirmation';
    }
  }
};
</script>
